module.exports = __webpack_public_path__ + "img/IMG_9674-7.4b2348f8.png";